import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Select } from '@ngxs/store';
import { Observable } from 'rxjs';
import { Breakpoint } from 'src/app/breakpoint/models/breakpoint.enum';
import { BreakpointState } from 'src/app/breakpoint/state/breakpoint.state';
import { CalloutContentModel } from 'src/app/shared/components/user-access/models/callout-content.model';
import { DialogService } from '../../dialog.service';

export type PremiumAccessDialogData = CalloutContentModel;

@Component({
  selector: 'app-premium-access-dialog',
  templateUrl: './premium-access-dialog.component.html',
  styleUrls: ['./premium-access-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PremiumAccessDialogComponent implements OnInit {
  breakPoints = Breakpoint;

  @Select(BreakpointState.getBreakpoint)
  breakpoint$: Observable<Breakpoint>;

  data: PremiumAccessDialogData;

  constructor(
    private router: Router,
    private dialogService: DialogService,
    public dialogRef: MatDialogRef<PremiumAccessDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: PremiumAccessDialogData,
  ) {
    this.data = data;
  }

  ngOnInit(): void {}

  handleCloseClick() {
    this.dialogRef.close(true);
  }

  handleActionClick() {
    this.dialogService.openUpgradeDialog(false);
  }

  handleSecondaryActionClick() {
    this.router.navigate(['/results/bookmarks']).then(() => {
      this.dialogRef.close();
    });
  }
}
